import React from 'react';
import { DeleteIcon, Link2Icon } from 'components/Icons';
import LinkEditorPopover from './LinkEditorPopover';

const PhotoFrame = React.memo(
  React.forwardRef(function PhotoFrame(props, ref) {
    const {
      layoutOptions,
      imageProps,
      overlay,
      active,
      insertPosition,
      attributes,
      listeners,
      onRemoveImage,
      imageId,
      handleImageLoad,
      config,
      updateLink,
      photo,
      linkEditorOpen,
      setLinkEditorOpen,
    } = props;
    const { alt, style, ...restImageProps } = imageProps;

    const globalLink = config?.link;
    const consolidatedLink = photo?.link || globalLink;

    const handleLinkPopoverOpen = (value) => {
      setLinkEditorOpen(value ? imageId : false);
    };

    const isLinkEditorOpen = linkEditorOpen === imageId;
    const allowedHover = !linkEditorOpen || isLinkEditorOpen;

    const { borderRadius } = style;

    return (
      <div
        ref={ref}
        style={{
          width: overlay ? `calc(100% - ${2 * layoutOptions.padding}px)` : style.width,
          marginBottom: style.marginBottom,
          background: '#fff',
          borderRadius: borderRadius + borderRadius * 0.1,
        }}
        className={`photo-frame
        ${allowedHover ? '' : 'no-hover'}
        ${isLinkEditorOpen ? 'hovered' : ''}
        ${overlay ? 'overlay' : ''}
        ${active ? 'active' : ''}
        ${insertPosition === 'before' ? 'insertBefore' : ''}
        ${insertPosition === 'after' ? 'insertAfter' : ''}
        `}
        {...attributes}
        {...listeners}>
        {allowedHover && (
          <div className="image-actions">
            <LinkEditorPopover
              {...{
                visible: isLinkEditorOpen,
                handleLinkPopoverOpen,
                imageId,
                updateLink,
                link: photo?.link,
                globalLink,
              }}
            />
            <DeleteIcon className="delete-icon" onClick={onRemoveImage} />
          </div>
        )}

        {consolidatedLink && (
          <div className="image-link-marker">
            <Link2Icon className="link-icon" />
          </div>
        )}

        <img
          alt={alt}
          // required to calculate the height and width
          {...(handleImageLoad ? { onLoad: handleImageLoad, id: imageId } : {})}
          style={{
            ...style,
            width: '100%',
            height: 'auto',
            marginBottom: 0,
          }}
          {...restImageProps}
        />
      </div>
    );
  })
);
export default PhotoFrame;
